module.exports = __webpack_public_path__ + "static/media/gamelogo.854658af.svg";